import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

import { BidLeaderStatusComponent } from './bid-leader-status.component';
import { NzToolTipModule } from 'ng-zorro-antd/tooltip';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzGridModule } from 'ng-zorro-antd/grid';

@NgModule({
  declarations: [BidLeaderStatusComponent],
  imports: [CommonModule, TranslateModule, NzToolTipModule, NzIconModule, NzGridModule],
  exports: [BidLeaderStatusComponent],
})
export class BidLeaderStatusModule {}
